import React from 'react';
import { LinkSection } from './link-section';
import { kebabCase } from 'lodash';
import { Box } from '@hub/box';
import { trackUniversalFooterLinkClick } from './analytics';
import { jsx as _jsx } from "react/jsx-runtime";
export const MembershipColumnLinks = _ref => {
  let {
    heading,
    links
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    as: "nav",
    "aria-labelledby": kebabCase(heading.text),
    "data-id": "universal-footer_membership-column-links_MembershipColumnLinks_Box",
    children: /*#__PURE__*/_jsx(LinkSection, {
      heading: heading,
      links: links,
      trackers: {
        clicked: trackUniversalFooterLinkClick
      },
      "data-id": "universal-footer_membership-column-links_MembershipColumnLinks_Box_LinkSection"
    })
  });
};